import {CountryModel} from './country.model';
import {CultureModel} from './culture.model';

export class NavigationModel {

  static getHomeURLPaths(pathsToAppend: string[]): string[] {

    const country = CountryModel.getHomepageCountry();
    const culture = CultureModel.getHomepageCulture();

    let paths = [];

    if (country && culture) {

      paths = ['home', country, culture].concat();

    } else {
      paths = ['home', CountryModel.GBR, CultureModel.enGB];

    }

    return paths.concat(pathsToAppend);

  }

  static getDefaultHomeURLPath(): string[] {

    return ['home', CountryModel.GBR, CultureModel.enGB, 'landing'];
  }

}
